'use client'

import { createRedirectIntent } from '@/feature/navigation/services/navigation.intents'
import type { TrackingGaEvent } from '@/lib/tracking/services/tracking.eventTypes'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'

import { Link } from '@/ui/links/link/Link.client'

export type SectionLinkProps = {
  name: string
  href: string
  opensInNewTab?: boolean
  analytics?: TrackingGaEvent
  className: string
}

export function SectionLink({
  name,
  href,
  opensInNewTab,
  analytics,
  className,
}: SectionLinkProps): React.ReactElement {
  const handlePress = () => {
    if (analytics) {
      pushToGtmDataLayer(analytics)
    }
  }

  const isNavigable = !!href && href !== '#'

  return (
    <Link
      variant="free"
      className={className}
      href={href}
      opensInNewTab={opensInNewTab}
      title={name}
      bold
      underlined="invert"
      onPress={handlePress}
      intent={isNavigable ? createRedirectIntent({ to: href }) : undefined}
    >
      {name}
    </Link>
  )
}
